import React, { useEffect, useState } from 'react'
import axios from 'axios'

const API = process.env.REACT_APP_API_URL || 'http://localhost:3001/api'

const DIAS = [{id:1,l:'Dom'},{id:2,l:'Seg'},{id:3,l:'Ter'},{id:4,l:'Qua'},{id:5,l:'Qui'},{id:6,l:'Sex'},{id:7,l:'Sáb'}]
const TIPOS = [
  {tipo:'movimento',    icone:'🚗', label:'Veículo em Movimento'},
  {tipo:'ignicao_on',   icone:'🔑', label:'Ignição Ligada'},
  {tipo:'ignicao_off',  icone:'🔒', label:'Ignição Desligada'},
  {tipo:'velocidade',   icone:'⚡', label:'Excesso de Velocidade'},
  {tipo:'fora_horario', icone:'🕐', label:'Fora de Horário'},
  {tipo:'desbloqueio',  icone:'🔓', label:'Regra de Desbloqueio'},
]
const FORM_VAZIO = {
  nome:'', tipo:'movimento', cliente_id:'', emails:[] as string[],
  dias_semana:[2,3,4,5,6] as number[],
  horario_inicio:'08:00', horario_fim:'18:00',
  bloqueio_auto:false, desbloqueio_auto:false,
  comando_bloqueio:'engineStop', comando_desbloqueio:'engineResume',
  parametros:{velocidade_max:80} as any,
  perfil_velocidade_id:'' as string,
  ativos_ids:[] as string[], ativo:true
}

export default function ConfigAlertas() {
  const [regras, setRegras]       = useState<any[]>([])
  const [clientes, setClientes]   = useState<any[]>([])
  const [ativos, setAtivos]       = useState<any[]>([])
  const [grupos, setGrupos]       = useState<any[]>([])
  const [perfisVelocidade, setPerfisVelocidade] = useState<any[]>([])
  const [modal, setModal]         = useState(false)
  const [editando, setEditando]   = useState<any>(null)
  const [form, setForm]           = useState<any>(FORM_VAZIO)
  const [filtroCliente, setFiltroCliente] = useState('')
  const [grupoFiltro, setGrupoFiltro]     = useState('')
  const [emailInput, setEmailInput]       = useState('')
  const [loading, setLoading]     = useState(true)
  const [salvando, setSalvando]   = useState(false)
  const [abaModal, setAbaModal]   = useState<'config'|'ativos'>('config')

  const carregar = async () => {
    try {
      const [rr, rc, rg, rp] = await Promise.all([
        axios.get(`${API}/alertas-regras`),
        axios.get(`${API}/clientes`),
        axios.get(`${API}/grupos`),
        axios.get(`${API}/perfis-velocidade`)
      ])
      setRegras(rr.data)
      setClientes(rc.data)
      setGrupos(rg.data)
      setPerfisVelocidade(rp.data)
    } catch {} finally { setLoading(false) }
  }

  useEffect(()=>{ carregar() },[])

  useEffect(()=>{
    if(!form.cliente_id) { setAtivos([]); return }
    axios.get(`${API}/ativos`).then(r=>
      setAtivos(r.data.filter((a:any)=>a.cliente_id===form.cliente_id))
    ).catch(()=>{})
  },[form.cliente_id])

  const abrirNovo = () => {
    setEditando(null)
    setForm(FORM_VAZIO)
    setAbaModal('config')
    setModal(true)
  }

  const abrirEditar = (r:any) => {
    setEditando(r)
    setForm({
      nome:r.nome, tipo:r.tipo, cliente_id:r.cliente_id||'',
      emails:r.emails||[], dias_semana:r.dias_semana||[2,3,4,5,6],
      horario_inicio:r.horario_inicio||'08:00',
      horario_fim:r.horario_fim||'18:00',
      bloqueio_auto:r.bloqueio_auto||false,
      desbloqueio_auto:r.desbloqueio_auto||false,
      comando_bloqueio:r.comando_bloqueio||'engineStop',
      comando_desbloqueio:r.comando_desbloqueio||'engineResume',
      parametros:r.parametros||{velocidade_max:80},
      perfil_velocidade_id:r.perfil_velocidade_id||'',
      ativos_ids:r.ativos_ids||[], ativo:r.ativo??true
    })
    setAbaModal('config')
    setModal(true)
  }

  const salvar = async () => {
    if(!form.nome) return alert('Nome é obrigatório')
    if(!form.tipo) return alert('Tipo é obrigatório')
    setSalvando(true)
    try {
      if(editando) await axios.put(`${API}/alertas-regras/${editando.id}`, form)
      else await axios.post(`${API}/alertas-regras`, form)
      setModal(false); carregar()
    } catch(e:any){ alert(e.response?.data?.erro||'Erro ao salvar') }
    finally { setSalvando(false) }
  }

  const excluir = async (id:string) => {
    if(!window.confirm('Excluir esta regra?')) return
    try { await axios.delete(`${API}/alertas-regras/${id}`); carregar() } catch {}
  }

  const toggleDia = (dia:number) => {
    const dias = form.dias_semana.includes(dia)
      ? form.dias_semana.filter((d:number)=>d!==dia)
      : [...form.dias_semana, dia]
    setForm({...form, dias_semana:dias})
  }

  const toggleAtivo = (id:string) => {
    const ids = form.ativos_ids.includes(id)
      ? form.ativos_ids.filter((x:string)=>x!==id)
      : [...form.ativos_ids, id]
    setForm({...form, ativos_ids:ids})
  }

  const addEmail = () => {
    if(!emailInput||form.emails.includes(emailInput)) return
    setForm({...form, emails:[...form.emails, emailInput]})
    setEmailInput('')
  }

  const ativosFiltrados = ativos.filter(a=>
    !grupoFiltro || a.grupo_id===grupoFiltro
  )

  const regrasFiltradas = regras.filter(r=>
    !filtroCliente || r.cliente_id===filtroCliente
  )

  const tipoInfo = (tipo:string) => TIPOS.find(t=>t.tipo===tipo)||{icone:'🔔',label:tipo}
  const fmtHora = (h:any) => h ? String(h).substring(0,5) : '—'

  return (
    <div style={{padding:24,height:'100%',overflowY:'auto'}}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:20}}>
        <div>
          <h2 style={{fontSize:20,fontWeight:700}}>🔔 Gestão de Alertas</h2>
          <p style={{fontSize:13,color:'#64748b'}}>{regrasFiltradas.length} regra(s) configurada(s)</p>
        </div>
        <button className="btn btn-primary" onClick={abrirNovo}>+ Nova regra</button>
      </div>

      {/* Filtros */}
      <div style={{display:'flex',gap:12,marginBottom:16}}>
        <select value={filtroCliente} onChange={e=>setFiltroCliente(e.target.value)} style={{minWidth:220}}>
          <option value="">Todos os clientes</option>
          {clientes.map((c:any)=><option key={c.id} value={c.id}>{c.razao_social}</option>)}
        </select>
        <select onChange={e=>{
          const tipo = e.target.value
          setRegras(prev=>tipo?prev.filter(r=>r.tipo===tipo):prev)
          if(!tipo) carregar()
        }} style={{minWidth:180}}>
          <option value="">Todos os tipos</option>
          {TIPOS.map(t=><option key={t.tipo} value={t.tipo}>{t.icone} {t.label}</option>)}
        </select>
      </div>

      {/* Grid de regras */}
      <div className="card" style={{padding:0,overflow:'hidden'}}>
        <table style={{width:'100%',borderCollapse:'collapse'}}>
          <thead>
            <tr style={{background:'#0d1b2e'}}>
              {['Nome','Tipo','Cliente','Dias','Horário','Ativos','Bloqueio','Status','Ações'].map(h=>(
                <th key={h} style={{padding:'10px 14px',textAlign:'left',fontSize:11,
                  color:'#64748b',fontWeight:600,textTransform:'uppercase'}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading?(
              <tr><td colSpan={9} style={{padding:24,textAlign:'center',color:'#64748b'}}>Carregando...</td></tr>
            ):regrasFiltradas.length===0?(
              <tr><td colSpan={9} style={{padding:24,textAlign:'center',color:'#64748b'}}>Nenhuma regra configurada</td></tr>
            ):regrasFiltradas.map((r:any)=>{
              const ti = tipoInfo(r.tipo)
              const dias = (r.dias_semana||[]).map((d:number)=>DIAS.find(x=>x.id===d)?.l).join(',')
              return (
                <tr key={r.id} style={{borderBottom:'1px solid rgba(45,65,102,0.4)'}}>
                  <td style={{padding:'10px 14px',fontSize:13,fontWeight:600}}>{r.nome}</td>
                  <td style={{padding:'10px 14px',fontSize:12}}>{ti.icone} {ti.label}</td>
                  <td style={{padding:'10px 14px',fontSize:12,color:'#94a3b8'}}>
                    {clientes.find(c=>c.id===r.cliente_id)?.razao_social||'Todos'}
                  </td>
                  <td style={{padding:'10px 14px',fontSize:11,color:'#94a3b8'}}>{dias||'Todos'}</td>
                  <td style={{padding:'10px 14px',fontSize:11}}>
                    {r.horario_inicio?`${fmtHora(r.horario_inicio)} - ${fmtHora(r.horario_fim)}`:'—'}
                  </td>
                  <td style={{padding:'10px 14px',fontSize:12,color:'#0ea5e9'}}>
                    {(r.ativos_ids||[]).length} ativo(s)
                  </td>
                  <td style={{padding:'10px 14px',fontSize:11}}>
                    {r.bloqueio_auto&&<span style={{background:'#450a0a',color:'#f87171',
                      padding:'1px 6px',borderRadius:8,fontSize:10}}>🔒 Auto</span>}
                    {r.desbloqueio_auto&&<span style={{background:'#14532d',color:'#4ade80',
                      padding:'1px 6px',borderRadius:8,fontSize:10,marginLeft:4}}>🔓 Auto</span>}
                    {!r.bloqueio_auto&&!r.desbloqueio_auto&&<span style={{color:'#475569'}}>—</span>}
                  </td>
                  <td style={{padding:'10px 14px'}}>
                    <span style={{fontSize:10,padding:'2px 8px',borderRadius:10,
                      background:r.ativo?'#14532d':'#1e293b',
                      color:r.ativo?'#4ade80':'#64748b'}}>
                      {r.ativo?'Ativo':'Inativo'}
                    </span>
                  </td>
                  <td style={{padding:'10px 14px'}}>
                    <div style={{display:'flex',gap:4}}>
                      <button className="btn btn-ghost" style={{padding:'4px 8px',fontSize:11}}
                        onClick={()=>abrirEditar(r)}>✏️</button>
                      <button className="btn btn-ghost" style={{padding:'4px 8px',fontSize:11,color:'#f87171'}}
                        onClick={()=>excluir(r.id)}>🗑️</button>
                    </div>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>

      {/* Modal */}
      {modal && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.6)',zIndex:1000,
          display:'flex',alignItems:'center',justifyContent:'center',padding:20}}>
          <div className="card" style={{width:'100%',maxWidth:640,maxHeight:'92vh',overflowY:'auto'}}>
            <div style={{display:'flex',justifyContent:'space-between',marginBottom:16}}>
              <h3>{editando?'✏️ Editar regra':'🔔 Nova regra de alerta'}</h3>
              <button className="btn btn-ghost" style={{padding:'4px 8px'}} onClick={()=>setModal(false)}>✕</button>
            </div>

            {/* Abas */}
            <div style={{display:'flex',gap:0,marginBottom:16,borderBottom:'1px solid #2d4166'}}>
              {([['config','⚙️ Configuração'],['ativos','🚗 Ativos']] as const).map(([id,label])=>(
                <button key={id} onClick={()=>setAbaModal(id)}
                  style={{padding:'8px 20px',border:'none',background:'transparent',cursor:'pointer',
                    fontFamily:'Inter',fontSize:13,fontWeight:abaModal===id?700:400,
                    color:abaModal===id?'#0ea5e9':'#64748b',
                    borderBottom:abaModal===id?'2px solid #0ea5e9':'2px solid transparent',
                    marginBottom:-1}}>
                  {label}
                </button>
              ))}
            </div>

            {abaModal==='config' && (
              <div className="form-grid">
                <div className="form-group full">
                  <label>Nome da regra *</label>
                  <input value={form.nome} onChange={e=>setForm({...form,nome:e.target.value})}
                    placeholder="Ex: Fora de horário - Frota Logística" />
                </div>
                <div className="form-group">
                  <label>Tipo de alerta *</label>
                  <select value={form.tipo} onChange={e=>setForm({...form,tipo:e.target.value})}>
                    {TIPOS.map(t=><option key={t.tipo} value={t.tipo}>{t.icone} {t.label}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Cliente</label>
                  <select value={form.cliente_id} onChange={e=>setForm({...form,cliente_id:e.target.value,ativos_ids:[]})}>
                    <option value="">Todos os clientes</option>
                    {clientes.map((c:any)=><option key={c.id} value={c.id}>{c.razao_social}</option>)}
                  </select>
                </div>

                {/* Perfil de velocidade */}
                {form.tipo==='velocidade' && (
                  <>
                    <div className="form-group full">
                      <label>⚡ Perfil de velocidade</label>
                      <select value={form.perfil_velocidade_id}
                        onChange={e=>{
                          const pid = e.target.value
                          const perfil = perfisVelocidade.find((p:any)=>p.id===pid)
                          setForm({...form,
                            perfil_velocidade_id:pid,
                            parametros:{...form.parametros,
                              velocidade_max:perfil?perfil.velocidade_max:form.parametros.velocidade_max}
                          })
                        }}>
                        <option value="">— Definir velocidade manualmente —</option>
                        {perfisVelocidade
                          .filter((p:any)=>!form.cliente_id||p.cliente_id===form.cliente_id)
                          .map((p:any)=>(
                          <option key={p.id} value={p.id}>{p.nome} — {p.velocidade_max} km/h ({p.total_ativos} ativos)</option>
                        ))}
                      </select>
                      <div style={{fontSize:11,color:'#475569',marginTop:4}}>
                        Ao selecionar um perfil, o limite é aplicado a todos os ativos do grupo e enviado ao ST8300 via GPRS.
                      </div>
                    </div>
                    {!form.perfil_velocidade_id && (
                      <div className="form-group full">
                        <label>⚡ Velocidade máxima manual (km/h)</label>
                        <input type="number" value={form.parametros.velocidade_max||80}
                          onChange={e=>setForm({...form,parametros:{...form.parametros,velocidade_max:parseInt(e.target.value)}})}
                          min="40" max="300" />
                      </div>
                    )}
                  </>
                )}

                {/* Dias da semana */}
                <div className="form-group full">
                  <label>📅 Dias da semana</label>
                  <div style={{display:'flex',gap:6,marginTop:4}}>
                    {DIAS.map(d=>(
                      <button key={d.id} type="button" onClick={()=>toggleDia(d.id)}
                        style={{padding:'6px 10px',borderRadius:8,border:'none',cursor:'pointer',
                          fontFamily:'Inter',fontSize:12,
                          background:form.dias_semana.includes(d.id)?'#0ea5e9':'#1a2744',
                          color:form.dias_semana.includes(d.id)?'#fff':'#94a3b8',
                          outline:form.dias_semana.includes(d.id)?'2px solid #0ea5e9':'1px solid #2d4166'}}>
                        {d.l}
                      </button>
                    ))}
                  </div>
                  <div style={{fontSize:10,color:'#475569',marginTop:4}}>
                    Dias marcados = dias em que o alerta está ATIVO
                  </div>
                </div>

                {/* Horários */}
                <div className="form-group">
                  <label>🕐 {form.tipo==='fora_horario'?'Início do horário permitido':'Horário início'}</label>
                  <input type="time" value={form.horario_inicio}
                    onChange={e=>setForm({...form,horario_inicio:e.target.value})} />
                </div>
                <div className="form-group">
                  <label>🕐 {form.tipo==='fora_horario'?'Fim do horário permitido':'Horário fim'}</label>
                  <input type="time" value={form.horario_fim}
                    onChange={e=>setForm({...form,horario_fim:e.target.value})} />
                </div>
                <div className="form-group full" style={{fontSize:11,color:'#475569',marginTop:-8}}>
                  Período em que o alerta está ATIVO. Fora deste período = sem notificação.
                </div>

                {/* Bloqueio automático */}
                <div className="form-group full">
                  <label>🔒 Ações automáticas</label>
                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8,marginTop:4}}>
                    <div onClick={()=>setForm({...form,bloqueio_auto:!form.bloqueio_auto})}
                      style={{padding:'10px 14px',borderRadius:8,cursor:'pointer',
                        border:`2px solid ${form.bloqueio_auto?'#f87171':'#2d4166'}`,
                        background:form.bloqueio_auto?'#450a0a':'transparent'}}>
                      <div style={{fontSize:12,fontWeight:600,color:form.bloqueio_auto?'#f87171':'#94a3b8'}}>
                        🔒 Bloqueio automático
                      </div>
                      <div style={{fontSize:10,color:'#475569',marginTop:2}}>
                        Bloqueia o veículo quando o alerta for acionado
                      </div>
                    </div>
                    <div onClick={()=>setForm({...form,desbloqueio_auto:!form.desbloqueio_auto})}
                      style={{padding:'10px 14px',borderRadius:8,cursor:'pointer',
                        border:`2px solid ${form.desbloqueio_auto?'#22c55e':'#2d4166'}`,
                        background:form.desbloqueio_auto?'#14532d':'transparent'}}>
                      <div style={{fontSize:12,fontWeight:600,color:form.desbloqueio_auto?'#4ade80':'#94a3b8'}}>
                        🔓 Desbloqueio automático
                      </div>
                      <div style={{fontSize:10,color:'#475569',marginTop:2}}>
                        Desbloqueia o veículo quando o alerta for acionado
                      </div>
                    </div>
                  </div>
                </div>

                {/* Comandos personalizados */}
                {(form.bloqueio_auto||form.desbloqueio_auto) && (
                  <>
                    {form.bloqueio_auto && (
                      <div className="form-group">
                        <label>Comando de bloqueio</label>
                        <input value={form.comando_bloqueio}
                          onChange={e=>setForm({...form,comando_bloqueio:e.target.value})}
                          placeholder="engineStop" style={{fontFamily:'monospace'}} />
                      </div>
                    )}
                    {form.desbloqueio_auto && (
                      <div className="form-group">
                        <label>Comando de desbloqueio</label>
                        <input value={form.comando_desbloqueio}
                          onChange={e=>setForm({...form,comando_desbloqueio:e.target.value})}
                          placeholder="engineResume" style={{fontFamily:'monospace'}} />
                      </div>
                    )}
                  </>
                )}

                {/* E-mails */}
                <div className="form-group full">
                  <label>📧 E-mails de notificação</label>
                  <div style={{display:'flex',gap:8}}>
                    <input value={emailInput} onChange={e=>setEmailInput(e.target.value)}
                      onKeyDown={e=>e.key==='Enter'&&addEmail()}
                      placeholder="email@exemplo.com" style={{flex:1,fontSize:12}} />
                    <button className="btn btn-ghost" style={{fontSize:12}} onClick={addEmail}>➕</button>
                  </div>
                  <div style={{display:'flex',flexWrap:'wrap',gap:4,marginTop:6}}>
                    {form.emails.map((em:string,i:number)=>(
                      <span key={i} onClick={()=>setForm({...form,emails:form.emails.filter((_:string,j:number)=>j!==i)})}
                        style={{fontSize:10,background:'#0c2a4a',color:'#38bdf8',padding:'2px 8px',
                          borderRadius:10,cursor:'pointer'}} title="Clique para remover">
                        {em} ✕
                      </span>
                    ))}
                  </div>
                </div>

                {/* Status */}
                <div className="form-group">
                  <label>Status</label>
                  <div style={{display:'flex',gap:8,marginTop:4}}>
                    {[{v:true,l:'✅ Ativo'},{v:false,l:'⏸ Inativo'}].map(op=>(
                      <div key={String(op.v)} onClick={()=>setForm({...form,ativo:op.v})}
                        style={{flex:1,padding:'8px',borderRadius:8,cursor:'pointer',textAlign:'center',
                          border:`2px solid ${form.ativo===op.v?'#22c55e':'#2d4166'}`,
                          background:form.ativo===op.v?'#0d2e1a':'transparent',
                          fontSize:12,color:form.ativo===op.v?'#22c55e':'#94a3b8'}}>
                        {op.l}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {abaModal==='ativos' && (
              <div>
                {!form.cliente_id ? (
                  <div style={{padding:20,textAlign:'center',color:'#64748b'}}>
                    Selecione um cliente na aba Configuração para ver os ativos
                  </div>
                ) : (
                  <>
                    <div style={{display:'flex',gap:8,marginBottom:12,alignItems:'center'}}>
                      <select value={grupoFiltro} onChange={e=>setGrupoFiltro(e.target.value)} style={{flex:1}}>
                        <option value="">Todos os grupos</option>
                        {grupos.map((g:any)=><option key={g.id} value={g.id}>{g.nome}</option>)}
                      </select>
                      <button className="btn btn-ghost" style={{fontSize:11}}
                        onClick={()=>setForm({...form,ativos_ids:
                          form.ativos_ids.length===ativosFiltrados.length?[]:ativosFiltrados.map((a:any)=>a.id)})}>
                        {form.ativos_ids.length===ativosFiltrados.length?'Desmarcar todos':'Selecionar todos'}
                      </button>
                    </div>
                    <div style={{maxHeight:380,overflowY:'auto'}}>
                      {ativosFiltrados.map((a:any)=>{
                        const sel = form.ativos_ids.includes(a.id)
                        return (
                          <div key={a.id} onClick={()=>toggleAtivo(a.id)}
                            style={{padding:'10px 14px',cursor:'pointer',
                              background:sel?'#0c2a4a':'transparent',
                              borderBottom:'1px solid rgba(45,65,102,0.3)',
                              borderLeft:`3px solid ${sel?'#0ea5e9':'transparent'}`}}>
                            <div style={{display:'flex',alignItems:'center',gap:10}}>
                              <div style={{width:18,height:18,borderRadius:4,
                                border:`2px solid ${sel?'#0ea5e9':'#2d4166'}`,
                                background:sel?'#0ea5e9':'transparent',
                                display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                                {sel&&<span style={{color:'white',fontSize:11}}>✓</span>}
                              </div>
                              <div>
                                <div style={{fontSize:13,fontWeight:sel?600:400}}>{a.nome}</div>
                                <div style={{fontSize:10,color:'#64748b'}}>{a.placa||'—'} {a.modelo_veiculo?`· ${a.modelo_veiculo}`:''}</div>
                              </div>
                            </div>
                          </div>
                        )
                      })}
                    </div>
                    <div style={{fontSize:12,color:'#64748b',marginTop:8,padding:'0 4px'}}>
                      {form.ativos_ids.length} ativo(s) selecionado(s)
                    </div>
                  </>
                )}
              </div>
            )}

            <div style={{display:'flex',gap:8,justifyContent:'flex-end',marginTop:20}}>
              <button className="btn btn-ghost" onClick={()=>setModal(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={salvar} disabled={salvando}>
                {salvando?'⏳ Salvando...':'💾 Salvar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
